/**
 * I SEGNALI DEGLI EFFETTI: chi ha qualcosa da festeggiare lo dice qui, e
 * basta. La Cassa, quando il servizio dei pagamenti accredita un versamento;
 * il guscio, quando fra i bonus attivi del conto ne compare uno nuovo.
 *
 * Sono eventi della finestra: chi li manda non sa se c'e' qualcuno ad
 * ascoltare (il componente Effetti, montato dal guscio Nova quando il modulo
 * Effetti e' acceso), e questo file non importa niente del sito, cosi' la
 * Cassa non si porta dietro la pioggia di monete.
 */
export const EVENTO_DEPOSITO = 'lvc:deposito';
export const EVENTO_BONUS = 'lvc:bonus';

/** Un versamento accreditato: {moneta: 'btc', importoCripto: '0.00163', importo: 100, valuta: 'EUR'}. */
export function annunciaDeposito(dettaglio) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENTO_DEPOSITO, {detail: dettaglio || {}}));
}

/** Un bonus nuovo fra quelli attivi: {importo: 50, valuta: 'EUR'}. */
export function annunciaBonus(dettaglio) {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(EVENTO_BONUS, {detail: dettaglio || {}}));
}
